// src/components/DatabaseExplorer/TablePagination.jsx

import React from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

export default function TablePagination({
  page,
  pageSize,
  pageSizeOptions,
  totalRecords,
  onPageChange,
  onPageSizeChange,
}) {
  const totalPages = Math.max(1, Math.ceil(totalRecords / pageSize));

  const start = totalRecords ? (page - 1) * pageSize + 1 : 0;

  const end = Math.min(page * pageSize, totalRecords);

  return (
    <div className="card-footer bg-white p-3">
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
        <div className="d-flex align-items-center gap-2 small">
          <span className="text-secondary">Rows per page</span>

          <select
            className="form-select form-select-sm"
            style={{ width: 90 }}
            value={pageSize}
            onChange={(event) => onPageSizeChange(Number(event.target.value))}
          >
            {pageSizeOptions.map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>

          <span className="text-secondary">
            {start}–{end} of {totalRecords}
          </span>
        </div>

        <div className="d-flex align-items-center gap-2">
          <button
            type="button"
            className="btn btn-sm btn-outline-primary"
            disabled={page <= 1}
            onClick={() => onPageChange(page - 1)}
            aria-label="Previous page"
          >
            <FiChevronLeft />
          </button>

          <span className="small text-secondary text-nowrap">
            Page {page} of {totalPages}
          </span>

          <button
            type="button"
            className="btn btn-sm btn-outline-primary"
            disabled={page >= totalPages}
            onClick={() => onPageChange(page + 1)}
            aria-label="Next page"
          >
            <FiChevronRight />
          </button>
        </div>
      </div>
    </div>
  );
}
